import styled from "styled-components";
import { getBreakpoints } from "../../../assets/store/cssBreakpoints";
const { xs, sm, md, lg, xl, xxl } = getBreakpoints();

export const NavbarOutterWrapper = styled.div`
    overflow: visible;
    left: 0;
    right: 0;
    z-index: 3;

    @media only screen and (max-width: ${sm}px) {
        /* bottom: ${(props) =>
            props.validOffer && !props.slider ? "-45px" : "0"}; */
    }
`;

export const StyledNavbarRow = styled.div`
    height: 65px;
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    margin: 0;
    width: 100%;
    box-sizing: border-box;

    @media only screen and (max-width: ${md}px) {
        height: 5vh;
        padding: 10px 5px;
    }

    @media only screen and (max-width: ${sm}px) {
        height: 60px;
        padding: 10px 5px;
    }
`;

export const AlternateNavbarRow = styled.div`
    &&& {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 7px;
        background: ${(props) => props.bgColor ?? "white"};
        padding: 5px 0;
        max-width: unset;
        margin: unset !important;
        height: unset !important;
    }
`;

export const NavbarExpirationRowWrapper = styled.div`
    color: ${(props) => (props.color ? props.color : "white")};
    font-style: ${(props) => (props.fontStyle ? props.fontStyle : "inherit")};
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "unset")};
    font-size: ${(props) =>
        props.fontSizeDesktop ? props.fontSizeDesktop : "inherit"};
    padding: 0 10px 10px;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    z-index: 10;
    width: 100%;
    box-sizing: border-box;

    @media only screen and (max-width: ${xxl}px) {
        font-size: ${(props) =>
            props.numOfColumns === 3 ? "1vw" : props.fontSizeDesktop};
    }

    @media only screen and (max-width: ${md}px) {
        font-size: ${(props) =>
            props.fontSizeTablet ? props.fontSizeTablet : "inherit"};
    }

    @media only screen and (max-width: ${sm}px) {
        font-size: ${(props) =>
            props.fontSizeMobile ? props.fontSizeMobile : "inherit"};
    }
`;

export const StyledNavbarButton = styled.button`
    &&&& {
        margin: unset !important;
        max-width: unset !important;
        width: 100%;
        cursor: pointer;
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 9px;
        transition: all 0.15s;
        font-family: inherit;
        white-space: nowrap;
        padding: ${(props) => (props.padding ? props.padding : "uns")};
        color: ${(props) => (props.color ? props.color : "white")};
        background-color: ${(props) =>
            props.backgroundColor ? props.backgroundColor : "black"};
        font-size: ${(props) => {
            const { fontSizeDesktop, couponSize } = props;

            if (couponSize === "450px") return "14px";
            return fontSizeDesktop ?? "inherit";
        }};
        font-style: ${(props) =>
            props.fontStyle ? props.fontStyle : "inherit"};
        font-weight: ${(props) =>
            props.fontWeight ? props.fontWeight : "unset"};
        border-radius: ${(props) =>
            props.borderRadius ? props.borderRadius : "unset"};
        text-transform: ${(props) =>
            props.textTransform ? props.textTransform : "unset"};
        letter-spacing: ${(props) =>
            props.letterSpacing ? props.letterSpacing : "unset"};

        &:hover {
            &.button_1 {
                ${(props) =>
                    props.activeFirstCta &&
                    `border: ${
                        props.borderColor
                            ? `1px solid ${props.borderColor}`
                            : "none" // this removes the border completely
                    };`}
            }
        }
        @media only screen and (max-width: ${md}px) {
            font-size: ${(props) =>
                props.fontSizeTablet ? props.fontSizeTablet : "inherit"};
        }

        @media only screen and (max-width: ${sm}px) {
            font-size: ${(props) =>
                props.fontSizeMobile ? props.fontSizeMobile : "14px"};
        }
        min-width: unset;
    }
`;

export const Button4 = styled.button`
    width: 100%;
    padding: 5px 0;
    cursor: pointer;
    color: ${(props) => props.textColor};
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    border: none;
    border-bottom: 3px solid ${(props) => props.backgroundColor};
    background-color: ${(props) => props.backgroundColor};
    transition: all 0.15s;
    margin: 0;
    font-size: ${(props) =>
        props.fontSizeDesktop ? props.fontSizeDesktop : "inherit"};
    text-transform: ${(props) =>
        props.textTransform ? props.textTransform : "unset"};
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "unset")};
    font-style: ${(props) => (props.fontStyle ? props.fontStyle : "unset")};

    svg {
        fill: ${(props) => props.textColor};
    }

    &:hover {
        background-color: ${(props) => props.hoverBackgroundColor};
        color: ${(props) => props.hoverTextColor};

        svg {
            fill: ${(props) => props.hoverTextColor};
        }
    }

    & > * {
        // stop pointer events on child elements so ga clicks register on button
        pointer-events: none;
    }

    @media only screen and (max-width: ${xxl}px) {
        font-size: ${(props) =>
            props.numOfColumns === 3 ? "1vw" : props.fontSizeDesktop};
    }

    @media only screen and (max-width: ${md}px) {
        font-size: ${(props) =>
            props.fontSizeTablet ? props.fontSizeTablet : "inherit"};
    }

    @media only screen and (max-width: ${sm}px) {
        font-size: ${(props) =>
            props.fontSizeMobile ? props.fontSizeMobile : "inherit"};
    }
`;

export const InteractiveButtonsWrapper = styled.div`
    &&&& {
        padding: ${(props) => (props.slider ? "" : "8px 16px")};
        display: flex;
        justify-content: flex-end;
        gap: 8px;

        @media only screen and (max-width: ${sm}px) {
            padding: 0px;
        }
    }

    @keyframes expandwidth {
        from {
            width: 67px;
        }
        50% {
            width: 180px;
        }
        75% {
            width: 140px;
        }
        to {
            width: max-content;
        }
    }
`;

export const ExpirationDateText = styled.span`
    padding: ${(props) => (props.slider ? "unset" : "8px 16px")};

    @media only screen and (max-width: ${sm}px) {
        padding: unset;
    }
`;

export const WatchVideoButton = styled.button`
    &&&& {
        padding: 14px;
        height: 54px;
        border: none;
        background-color: ${(props) => props.backgroundColor};
        color: ${(props) => props.textColor};
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: ${(props) => props.borderRadius ?? "1000px"};
        min-width: unset;
        fill: ${(props) => props.textColor};
        white-space: unset;
        z-index: 3;

        @media only screen and (max-width: ${sm}px) {
            height: 45px;
            width: 80%;
        }
    }

    &&&&:hover {
        background-color: ${(props) => props.hoverBackgroundColor};
        color: ${(props) => props.hoverTextColor};
        fill: ${(props) => props.hoverTextColor};
    }
`;

export const StyledExpirationRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: end;
    font-family: inherit;
`;

export const ModalDiv = styled.div`
    position: fixed; /* Stay in place */
    z-index: 10000; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(2px);
    overflow: hidden;
    background-color: #000000ab;
    backdrop-filter: blur(2px);
`;

export const ModalContent = styled.div`
    width: 80%;
    height: 100%;
    z-index: 10100;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    @media only screen and (max-width: 576px) {
        width: 90% !important;
    }
`;

export const CloseButtonWrapper = styled.div`
    &&&& {
        cursor: pointer;
        z-index: 10201;
        position: absolute;
        right: 8px;
        top: 10em;

        @media only screen and (max-width: ${sm}px) {
            right: 0px;
        }
    }
`;

export const StyledIframe = styled.iframe`
    &&&&&& {
        z-index: 10100;
        width: 80%;
        aspect-ratio: 16 / 9;

        @media only screen and (max-width: ${sm}px) {
            width: 90%;
            height: 90%;
        }
    }
`;

export const StyledButtonText = styled.span`
    font-style: ${(props) => (props.fontStyle ? props.fontStyle : "inherit")};
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "unset")};
    font-size: ${(props) =>
        props.fontSizeDesktop ? props.fontSizeDesktop : "inherit"};
    line-height: 1;
    pointer-events: none;
    text-transform: ${(props) => (props.textTransform ? props.textTransform : "none")};
    letter-spacing: ${(props) => (props.letterSpacing ? props.letterSpacing : "unset")};

    @media only screen and (max-width: ${md}px) {
        font-size: ${(props) =>
            props.fontSizeTablet ? props.fontSizeTablet : "inherit"};
    }

    @media only screen and (max-width: ${sm}px) {
        font-size: ${(props) =>
            props.fontSizeMobile ? props.fontSizeMobile : "inherit"};
    }
`;
